module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Modbus_Icon.b588ed78.png";